export const fonts = {
  body: '"Open Sans", sans-serif',
  heading: '"Open Sans", sans-serif',
};
